import { type FC } from "react";
import { Dialog } from "@mui/material";
import { useSnackbar } from "notistack";
import { useTranslation } from "react-i18next";
import { useCreatePlatformPageMutation } from "@/partner/entities/platformPages";
import { type PlatformPageFormValues } from "../model";
import { PageForm } from "./PageForm";

interface CreatePageDialogProps {
  open: boolean;
  onClose: () => void;
  onCompleted?: () => void;
}

export const CreatePageDialog: FC<CreatePageDialogProps> = ({
  open,
  onClose,
  onCompleted,
}) => {
  const { enqueueSnackbar } = useSnackbar();
  const { t } = useTranslation();

  const [createPlatformPage, { loading }] = useCreatePlatformPageMutation({
    onCompleted: () => {
      enqueueSnackbar(t("platformPages.snackbar.created"), {
        variant: "success",
      });
    },
    onError: (error) => {
      enqueueSnackbar(error.message, { variant: "error" });
    },
    refetchQueries: ["PlatformPagesList"],
  });

  const handleSubmit = async (values: PlatformPageFormValues) => {
    await createPlatformPage({
      variables: {
        input: values,
      },
    });

    onCompleted?.();
  };

  return (
    <Dialog
      fullScreen
      fullWidth
      maxWidth="md"
      scroll="body"
      open={open}
      onClose={onClose}
    >
      <PageForm
        onSubmit={handleSubmit}
        onClose={onClose}
        title={t("platformPages.create.title")}
        loading={loading}
      />
    </Dialog>
  );
};
